import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Tooltip } from '@mui/material';
import React__default, { useState, useRef } from 'react';
import { useCopyToClipboard } from 'react-use';
import '../Icons/Add.js';
import '../Icons/Application.js';
import '../Icons/AppStore.js';
import '../Icons/Arrow.js';
import '../Icons/At.js';
import '../Icons/Attach.js';
import '../Icons/Bank.js';
import '../Icons/Battery.js';
import '../Icons/Bell.js';
import '../Icons/Blocked.js';
import '../Icons/Calendar.js';
import '../Icons/Card.js';
import '../Icons/CaretDown.js';
import '../Icons/CaretLeft.js';
import '../Icons/CaretRight.js';
import '../Icons/CaretUp.js';
import '../Icons/Checkbox.js';
import '../Icons/CheckboxChecked.js';
import '../Icons/CheckboxIndeterminate.js';
import '../Icons/ChevronLeft.js';
import '../Icons/ChevronRight.js';
import '../Icons/Company.js';
import Copy from '../Icons/Copy.js';
import '../Icons/Currency.js';
import '../Icons/Customers.js';
import '../Icons/Dash.js';
import '../Icons/Dashboard.js';
import '../Icons/DirectionDown.js';
import '../Icons/DirectionUp.js';
import '../Icons/Document.js';
import '../Icons/DoubleChevronLeft.js';
import '../Icons/DoubleChevronRight.js';
import '../Icons/DoubleDirectionDown.js';
import '../Icons/DoubleDirectionUp.js';
import '../Icons/Download.js';
import '../Icons/Edit.js';
import '../Icons/ExclamationMark.js';
import '../Icons/ExclamationMarkFilled.js';
import '../Icons/ExternalLink.js';
import '../Icons/EyeClosed.js';
import '../Icons/EyeOpen.js';
import '../Icons/Fingerprint.js';
import '../Icons/Folder.js';
import '../Icons/Forever.js';
import '../Icons/Funnel.js';
import '../Icons/GooglePlay.js';
import '../Icons/Iban.js';
import '../Icons/Id.js';
import '../Icons/Info.js';
import '../Icons/InfoFilled.js';
import '../Icons/Instant.js';
import '../Icons/Ip.js';
import '../Icons/Link.js';
import '../Icons/List.js';
import '../Icons/Mail.js';
import '../Icons/Menu.js';
import '../Icons/Message.js';
import '../Icons/MessageDot.js';
import '../Icons/Onboarding.js';
import '../Icons/Padlock.js';
import '../Icons/PadlockOpen.js';
import '../Icons/Percent.js';
import '../Icons/Play.js';
import '../Icons/PowerOff.js';
import '../Icons/ProcessCompleted.js';
import '../Icons/ProcessCountEight.js';
import '../Icons/ProcessCountFive.js';
import '../Icons/ProcessCountFour.js';
import '../Icons/ProcessCountNineAndMore.js';
import '../Icons/ProcessCountOne.js';
import '../Icons/ProcessCountSeven.js';
import '../Icons/ProcessCountSix.js';
import '../Icons/ProcessCountThree.js';
import '../Icons/ProcessCountTwo.js';
import '../Icons/ProcessFailed.js';
import '../Icons/ProcessInProgress.js';
import '../Icons/ProcessNotStarted.js';
import '../Icons/ProcessPartialInProgress.js';
import '../Icons/ProcessPaused.js';
import '../Icons/Profile.js';
import '../Icons/Progress.js';
import '../Icons/Provider.js';
import '../Icons/QuestionMark.js';
import '../Icons/QuestionMarkFilled.js';
import '../Icons/Remove.js';
import '../Icons/Repeat.js';
import '../Icons/Reset.js';
import '../Icons/RoundArrow.js';
import '../Icons/RoundArrowFilled.js';
import '../Icons/RoundCheckOutlined.js';
import '../Icons/RoundCheckOutlinedFilled.js';
import '../Icons/RoundClose.js';
import '../Icons/RoundCloseFilled.js';
import '../Icons/RoundLeft.js';
import '../Icons/RoundLeftFilled.js';
import '../Icons/RoundMinus.js';
import '../Icons/RoundMinusFilled.js';
import '../Icons/RoundPlus.js';
import '../Icons/RoundPlusFilled.js';
import '../Icons/RoundRight.js';
import '../Icons/RoundRightFilled.js';
import '../Icons/Settings.js';
import '../Icons/SettingsCog.js';
import '../Icons/Shield.js';
import '../Icons/StarFilled.js';
import '../Icons/StarOutlined.js';
import Success from '../Icons/Success.js';
import '../Icons/Timer.js';
import '../Icons/Trash.js';
import '../Icons/Upload.js';
import '../Icons/User.js';
import '../Icons/VerticalDots.js';
import '../Icons/World.js';
import '../Icons/Wrench.js';
import '../Icons/Zoom.js';

const ClipboardCopy = (_a) => {
    var { children, "data-testid": dataTestId, tooltipMessage, textToCopy, isCopyIconVisibleByDefault, isTextTruncated = true } = _a, props = __rest(_a, ["children", "data-testid", "tooltipMessage", "textToCopy", "isCopyIconVisibleByDefault", "isTextTruncated"]);
    const [, copyToClipboard] = useCopyToClipboard();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const rootRef = useRef(null);
    const closeTooltip = () => setTooltipOpen(false);
    const handleOnClick = (event) => {
        if (event.target instanceof HTMLAnchorElement) {
            event.stopPropagation();
            return;
        }
        if (textToCopy) {
            copyToClipboard(textToCopy);
        }
        else if (React__default.isValidElement(children) && rootRef.current) {
            const text = trimLastList(rootRef.current.innerText);
            copyToClipboard(text);
        }
        else {
            copyToClipboard(String(children));
        }
        setTooltipOpen(true);
    };
    const Icon = tooltipOpen ? Success : Copy;
    const shouldShowIcon = tooltipOpen || (!tooltipOpen && isCopyIconVisibleByDefault);
    return (jsx(Tooltip, { PopperProps: { disablePortal: true }, leaveDelay: 300, open: tooltipOpen, placement: "bottom-end", title: tooltipMessage !== null && tooltipMessage !== void 0 ? tooltipMessage : "Copied to Clipboard!", onClose: closeTooltip, arrow: true, disableFocusListener: true, children: jsxs(Root, Object.assign({ "$isTextTruncated": isTextTruncated, "data-testid": dataTestId, ref: rootRef, onClick: handleOnClick }, props, { children: [jsx("span", { children: children }), jsx(Icon, { role: "button", sx: {
                        ml: 1,
                        fontSize: 20,
                        gridRow: 1,
                        color: "primary.main",
                        cursor: "pointer",
                        opacity: shouldShowIcon ? 1 : [1, 1, 1, 0],
                        transition: "opacity 300ms ease-in-out",
                    } })] })) }));
};
const Root = styled("div")(({ theme, $isTextTruncated }) => (Object.assign({ display: "inline-grid", cursor: "pointer", width: "fit-content", "&:hover": {
        svg: {
            opacity: 1,
        },
    }, "& > span": Object.assign(Object.assign({}, ($isTextTruncated && {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    })), { gridRow: 1 }) }, theme.typography.small)));
const trimLastList = (text) => {
    if (text.includes("\n")) {
        return text.split("\n").slice(0, -1).join("\n");
    }
    return text;
};

export { ClipboardCopy };
//# sourceMappingURL=index.js.map
